import { Component, OnInit, Inject } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PermitDialogData {
  permitType: string; // e.g., 'IFQ', 'LE', or 'Open Access'
}

@Component({
    selector: 'app-permit-num-dialog',
    templateUrl: './permit-num-dialog.component.html',
    styleUrls: ['./permit-num-dialog.component.css'],
    standalone: false
})
export class PermitNumDialogComponent implements OnInit {

  number!: FormControl;

  constructor(
    public dialogRef: MatDialogRef<PermitNumDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PermitDialogData
  ) { }

  ngOnInit(): void {
    let pattern = this.data.permitType === 'Open Access' ? '^[0-9]{6}$' : '^[0-9]{4}$';
    this.number = new FormControl('', [
      Validators.required,
      Validators.pattern(pattern)
    ]);
  }

  confirm() {
    if (this.number.valid) {
      this.dialogRef.close(this.number.value);
    } else {
      this.number.markAsTouched();
    }
  }

  _forbidNonNumeric(control: AbstractControl) {
    control.setValue(control.value.replace(/[^0-9]/g, ''), { onlySelf: true, emitEvent: false });
  }
}
